import { CIPPrediction } from "constants/constantStrings";

const getDaysFormatted = value => {
  let message = null;
  if (value <= 30) {
    message = CIPPrediction.predictionCleaningDays.replace("%", value);
  } else if (value > 30 && value <= 37) {
    message = CIPPrediction.predictionCleaningDays.replace("% Days", "5 weeks");
  } else if (value > 37 && value <= 44) {
    message = CIPPrediction.predictionCleaningDays.replace("% Days", "6 weeks");
  } else if (value > 44 && value <= 51) {
    message = CIPPrediction.predictionCleaningDays.replace("% Days", "7 weeks");
  } else if (value > 51 && value <= 59) {
    message = CIPPrediction.predictionCleaningDays.replace("% Days", "8 weeks");
  } else if (value >= 60) {
    message = CIPPrediction.predictionCleaningDays.replace("% Days", "over 2 months");
  }
  return message;
};

const PredictionData = value => [
  {
    variable: CIPPrediction.flow,
    cc: value.Flow_RMNG_CC_Cycles_BF_NXT_CIP,
    proposedCleaning: getDaysFormatted(value.Flow_RMNG_Days_BF_NXT_CIP)
  },
  {
    variable: CIPPrediction.dp,
    cc: value.dP_RMNG_CC_Cycles_BF_NXT_CIP,
    proposedCleaning: getDaysFormatted(value.dP_RMNG_Days_BF_NXT_CIP)
  },

  {
    variable: CIPPrediction.Sp,
    cc: value.SP_RMNG_CC_Cycles_BF_NXT_CIP,
    proposedCleaning: getDaysFormatted(value.SP_RMNG_Days_BF_NXT_CIP)
  }
];

export const CipPredictionData = value => PredictionData(value);
